import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Configuration from 'src/config/configuration';
import NetworkRequest from "../../../config/network";
import { getConvertedParams, getParametersHeaderPost } from 'src/config/helper';

export const otpVerification = createAsyncThunk(
    "otpVerification",
    async ({ params, tenantId }: { params: {}; tenantId: string }) => {
      try {
        const response = await NetworkRequest.post(
            getConvertedParams(Configuration.apis.verifyOtp, params),
            {}, getParametersHeaderPost({ tenantId: tenantId }),
        );
        if (response.status) {
          const resultData = response.data;
          return resultData;
        }
      } catch (err) {
        console.log(err);
      }
    },
  );

  interface otpVerificationState {
    data: [];
    error: string | null;
    message: string | null;
    status: boolean;
    statusCode: number;
  }
  
  interface getotpVerification {
    report: otpVerificationState;
    otpLoader: boolean;
    error: any;
  }
  
  const otpVerificationInitialApiResponse: otpVerificationState = {
    data: [],
    error: "",
    message: "",
    status: false,
    statusCode: 0,
  };
  
  const otpVerificationInitialState: getotpVerification = {
    report: otpVerificationInitialApiResponse,
    otpLoader: false,
    error: {},
  } satisfies getotpVerification as getotpVerification;

  const otpVerificationSlice = createSlice({
    name: "verifyOtp",
    initialState: otpVerificationInitialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(otpVerification.pending, (state) => {
          state.otpLoader = true;
          state.error = "";
          state.report = otpVerificationInitialApiResponse
        })
        .addCase(otpVerification.fulfilled, (state, action) => {
          state.otpLoader = false;
          state.error = "";
          state.report = action.payload;
        })
        .addCase(otpVerification.rejected, (state, action) => {
          state.otpLoader = false;
          state.error = action.payload;
          state.report = otpVerificationInitialApiResponse;
        });
    },
  });

export default otpVerificationSlice.reducer;
